import {
    GET_ALL_DAYS,
    SAVE_REGULARIZATION,
    GET_REGULARIZATION_DETAILS,
    SAVE_NOT_AT_SITE_ATTENDANCE,
    GET_ATTENDANCE_DETAILS,
    MARK_CHECK_OUT,
    REGULARIZE_ATTENDANCE,
    GET_REGULARIZATION_FILTER,
    ATTENDANCE_DATA,
    MONTHS_FILTER
} from "./type";

const initialState = {
    getAllTheDaysData: [],
    insertRegularization: [],
    regularizationDetails: [],
    insertNonSiteAttendance: [],
    attendanceDetails: [],
    nonSiteCheckout: [],
    approveRejectRegularization: [],
    regularizationFilter: [],
    getAttendanceData: [],
    getMonthsFilter: []
};

const DarwinAttendanceSync = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case GET_ALL_DAYS:
            return {
                ...state,
                getAllTheDaysData: payload,
            };
        case SAVE_REGULARIZATION:
            return {
                ...state,
                insertRegularization: payload,
            };
        case GET_REGULARIZATION_DETAILS:
            return {
                ...state,
                regularizationDetails: payload,
            };
        case SAVE_NOT_AT_SITE_ATTENDANCE:
            return {
                ...state,
                insertNonSiteAttendance: payload,
            };
        case GET_ATTENDANCE_DETAILS:
            return {
                ...state,
                attendanceDetails: payload,
            };
        case MARK_CHECK_OUT:
            return {
                ...state,
                nonSiteCheckout: payload,
            };
        case REGULARIZE_ATTENDANCE:
            return {
                ...state,
                approveRejectRegularization: payload,
            };
        case GET_REGULARIZATION_FILTER:
            return {
                ...state,
                regularizationFilter: payload,
            };
        case ATTENDANCE_DATA:
            return {
                ...state,
                getAttendanceData: payload,
            };
        case MONTHS_FILTER:
            return {
                ...state,
                getMonthsFilter: payload,
            };
        default:
            return {...state};
    }
};

export default DarwinAttendanceSync;